/**
 * 预渲染页面混入
 * 为每个页面提供预渲染相关的功能
 */
/**
 * 预渲染页面混入
 * 为页面提供预渲染 + SEO 协同能力
 */
export default {
  data () {
    return {
      isPrerendering: false,
      pageLoaded: false,
      dataLoaded: false,
    }
  },

  created () {
    this.isPrerendering = this.$prerender.isPrerendering()
  },

  mounted () {
    this.pageLoaded = true
    this.initPageSEO()

    this.$prerender.clientOnly(() => {
      this.onClientMounted()
    })

    if (this.$prerender.isDetailPage()) {
      this.handleDetailPageSEO()
    }
  },

  methods: {
    onClientMounted () {
      // 子组件可重写
    },

    async safeApiCall (apiCall, fallbackData = null) {
      return await this.$prerender.skipInPrerender(apiCall, fallbackData)
    },

    async smartDetailFetch (apiCall, pageType = 'letting') {
      const id = this.$prerender.getPageId() || (this.$route.query && this.$route.query.id)

      try {
        const result = await this.$prerender.smartDataFetch(apiCall, pageType, id)
        this.dataLoaded = true

        if (!this.isPrerendering && result) {
          this.$prerender.setDynamicSEO(result, `${pageType}Detail`)
        }

        this.$prerender.ensureRouteSEO(this.$route, result)

        if (this.isPrerendering) {
          this.$nextTick(() => {
            this.$prerender.triggerRenderEvent({
              fallback: !this.$prerender.isDataReadyForPrerender(result),
            })
          })
        }

        return result
      } catch (error) {
        console.error('Smart detail fetch failed:', error)
        this.dataLoaded = true

        const fallbackData = this.$prerender.generateDefaultDetailData(pageType, id)
        this.$prerender.ensureRouteSEO(this.$route, fallbackData)

        if (this.isPrerendering) {
          this.notifyRenderComplete(fallbackData)
        }

        return fallbackData
      }
    },

    handleDetailPageSEO () {
      this.$watch('dataLoaded', (loaded) => {
        if (!loaded || !this.info) return
        const pageType = this.getDetailPageType()
        this.$prerender.setDynamicSEO(this.info, `${pageType}Detail`)
        this.$prerender.ensureRouteSEO(this.$route, this.info)
      }, { immediate: true })
    },

    getDetailPageType () {
      const path = (this.$route && this.$route.path) || ''
      if (path.includes('letting')) return 'letting'
      if (path.includes('house')) return 'house'
      if (path.includes('management')) return 'management'
      return 'letting'
    },

    setSEO (seoData) {
      if (!seoData) return
      this.$prerender.applySeoPayload(seoData, {
        route: this.$route,
        data: this.info || {},
      })
    },

    getPageName () {
      return (this.$route && this.$route.name) || 'Home'
    },

    initPageSEO () {
      const pageName = this.getPageName()
      const defaultSEO = this.$prerender.getDefaultSEO(pageName)
      this.setSEO(defaultSEO)
      this.$prerender.ensureRouteSEO(this.$route)
    },

    notifyRenderComplete (data = null) {
      if (!this.isPrerendering) return
      this.$nextTick(() => {
        const payload = data || this.info
        this.$prerender.triggerRenderEvent({
          fallback: !this.$prerender.isDataReadyForPrerender(payload),
        })
      })
    },
  }
}
